
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      chosenFileCatalog: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
    };
  },
  methods: {
    submitContent() {
      // const data = {
      //     title: this.title,
      //     text: this.description,
      //     language: this.language
      // }
      // store.dispatch("admin/submitAboutUsContent", data)
      const data = {
        store: store.state.admin.landing.catalogData,
        image: this.chosenFileCatalog,
      };
      store.dispatch("admin/submitCatalogContent", data);
    },

    uploadCertificateImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch("admin/upadetCatalogImage", event?.target?.result);
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFileCatalog = formData;
      }
    },

    banner(image: string) {
      if (image !== "") {
        return this.url + image;
      } else {
        return "";
      }
    },

    deleteCategory(id: string) {
      store.dispatch("admin/deleteCatalog", id);
    },
  },
  computed: {
    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    catalogs() {
      return store.state.admin.landing.catalogs;
    },

    link: {
      get(): string {
        return store.state.admin.landing.catalogData.link;
      },
      set(value: string): void {
        store.dispatch("admin/updateCatalogLink", value);
      },
    },
    linkError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    text: {
      get(): string {
        return store.state.admin.landing.catalogData.text;
      },
      set(value: string): void {
        store.dispatch("admin/updateCatalogText", value);
      },
    },
    textError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    language: {
      get(): string {
        return store.state.admin.landing.catalogData.language;
      },
      set(value: any): void {
        store.dispatch("admin/updateCatalogLanguage", value);
      },
    },
    languageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.language?.$dirty) {
        return errors;
      }
      !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    isLoading(): boolean {
      return store.state.app.loading;
    },
  },

  created() {
    store.dispatch("admin/getCatalogs");
  },

  validations: {
    language: {
      required,
    },
    link: {
      required,
    },
    text: {
      required,
    },
  },
});
